import { Box, Link } from '@mui/material';
import SpaceBox from './SpaceBox';
import { ReactComponent as LobsterLogo } from '../svg/lobster_logo.svg';

export default function Footer() {
  return (
    <Box
      sx={{
        padding: { xs: '34px 30px', sm: '40px 30px 50px 30px' },
        backgroundColor: '#1E1E1E',
        color: 'info.main',
        fontFamily: 'noto sans kr',
      }}
    >
      <Box
        sx={{
          maxWidth: { sm: '1200px' },
          margin: { sm: 'auto' },
        }}
      >
        <Box
          sx={{
            width: { xs: '80px', sm: '115px' },
            height: { xs: '24px', sm: '50px' },
            display: 'inline-block',
          }}
        >
          <LobsterLogo />
        </Box>
        <SpaceBox height={20} smHeight={40} />
        <Box sx={{ fontSize: { xs: '14px', sm: '15px' }, fontWeight: 700 }}>주식회사 로브스터</Box>
        <SpaceBox height={8} />
        <Box sx={{ fontSize: { xs: '13px', sm: '15px' }, fontWeight: 400, lineHeight: '21px' }}>
          대표 양주영
          <br />
          사업자번호 736-88-03399
          <br />
          서울시 강남구 테헤란로10길 16, 쁠랑빌딩 5층
          <br />
        </Box>

        <SpaceBox height={50} smHeight={40} />
        <Box sx={{ lineHeight: '21px', fontSize: { xs: '13px', sm: '15px' }, fontWeight: 400 }}>
          문의 support@mumble.kr
          <br />
          <Link
            sx={{ color: 'info.main', textDecoration: 'none' }}
            href={'https://mumble.kr/policies/terms.html'}
          >
            이용약관
          </Link>{' '}
          |{' '}
          <Link
            sx={{ color: 'info.main', textDecoration: 'none' }}
            href={'https://mumble.kr/policies/privacy.html'}
          >
            개인정보처리방침
          </Link>
          |{' '}
          <Link
            sx={{ color: 'info.main', textDecoration: 'none' }}
            href={'https://mumble.kr/notice/'}
          >
            공지사항
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
